// extracted by mini-css-extract-plugin
export default {"container":"timeline_container__A+FhL","time":"timeline_time__jSlQm"};